import { createFileRoute } from '@tanstack/react-router'

import { MmpvScreen } from './-components/mmpv-screen.tsx'

export const Route = createFileRoute('/merchants/mmpv')({
  component: MmpvScreen
})
